import React, { useEffect } from 'react';
import './PolicyModal.css';

/**
 * PolicyModal Component
 *
 * Displays Terms of Service or Privacy Policy in a modal popup
 * Allows users to read policies without leaving signup page
 */
const PolicyModal = ({ isOpen, onClose, type, children }) => {
  // Close modal on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const title = type === 'terms' ? 'Terms of Service' : 'Privacy Policy';

  return (
    <div className="policy-modal-overlay" onClick={onClose}>
      <div className="policy-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="policy-modal-header">
          <h2>{title}</h2>
          <button
            className="policy-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>

        {/* Modal Content */}
        <div className="policy-modal-content">
          {children}
        </div>

        {/* Modal Footer */}
        <div className="policy-modal-footer">
          <button className="btn-modern primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
